export default {
  /**
   * @description setToken 设置登录token
   */
  setToken: ({ commit }, data) => {
    commit('setToken', data);
    commit('setLastLoginType', data.role);
  },
  /**
   * @description setLoginData 设置登录数据
   */
  setLoginData: ({ commit }, data) => {
    commit('setLoginData', data);
  },
  logout: ({ commit }, role) => {
    commit('cleanToken', role);
    commit('cleanLoginData', role);
    commit('cleanLastLoginType');
  },
  cleanLoginData: ({ commit }, role) => {
    commit('cleanLoginData', role);
  },
  /**
   * @description 设置状态数据
   * @function setStatusData
   * @param {Object} action action object
   * @param {Object} data 状态数据
   */
  setStatusData: ({ commit }, data) => {
    switch (data.role) {
      default: {
        commit('setStudentStatus', data.status);
        break;
      }
    }
  },
  triggerWelfare: ({ commit }) => {
    commit('triggerWelfare');
  },
  setComData: ({ commit }, data) => {
    commit('setComData', data);
  },
  setComDataReset: ({ commit }, data) => {
    commit('setComDataReset', data);
  }
};
